
/* eslint-disable */
import React from 'react';
import { NavLink } from 'react-router-dom';
import CommonClass from '../../js/common';
const Header = ({ children }) => (
    <header>
        <div>
            <NavLink to="/home" exact><img id="logo" src={CommonClass.cdn_url + "images/aspiricx-logo.svg"} /></NavLink>
        </div>
       
        <div className="socialMediaWrap leftB">
            <a className="facebook" href="https://www.facebook.com/aspiricx/" title="aspiricx | Facebook" target="_blank"><img src={CommonClass.cdn_url + "images/facebook.svg"} /></a>
            <a className="twitter" href="https://twitter.com/aspiricx" title="aspiricx | Twitter" target="_blank"><img src={CommonClass.cdn_url + "images/twitter.svg"} /></a>
            <a className="linkedin" href="https://in.linkedin.com/company/aspiricx" title="aspiricx | LinkedIn" target="_blank"><img src={CommonClass.cdn_url + "images/linkedin.svg"} /></a>
            <a className="instagram" href="https://www.instagram.com/aspiricx" title="aspiricx | Instagram" target="_blank"><img src={CommonClass.cdn_url + "images/instagram.svg"} /></a>
        </div>
    </header>
)

export default Header


// WEBPACK FOOTER //
// src/components/Common/Header.js